// extracted by mini-css-extract-plugin
module.exports = {"logo":"style_logo__3Nz6A","logo__link":"style_logo__link__1GEET","logo__image":"style_logo__image__1MsFO"};